import { type FlowAction } from '../types';
import { useLayoutData } from './useLayoutContext';
import { useTranslation } from '../i18n/i18n';

/** What every embedded page needs to word its copy. */
export function useEmbeddedCopy() {
  const { t } = useTranslation();
  const { client, requestType, requestedDataGroups } = useLayoutData();
  const issuance = requestType === 'issuance';
  return {
    t,
    issuance,
    org: client?.name || t('sidebar.defaultClientName'),
    groups: requestedDataGroups ?? [],
    /** Picks the issuance wording of a key when there is one. */
    pick: (shareKey: string, issuanceKey: string) =>
      issuance ? issuanceKey : shareKey,
  };
}

/** "Use another app", when the person has another app to go back to. */
export function useAnotherApp(onBack?: () => void): FlowAction | undefined {
  const { t } = useTranslation();
  return onBack
    ? { label: t('embedded.useAnotherApp'), onClick: onBack }
    : undefined;
}
